import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DescriptionModel } from '@core/services/base.model';

@Component({
  selector: 'Teranet-MultiSelectSearch',
  templateUrl: './multi-select-search.component.html'
})
export class MultiSelectSearchComponent implements OnInit {
  @Input() allOptions: DescriptionModel[];
  @Input() placeHolder: string = 'Search';
  private _selectOptions: any;
  get selectOptions(): DescriptionModel[] {
    return this._selectOptions;
  }
  @Input()
  set selectOptions(value: DescriptionModel[]) {
    if (this._selectOptions === value) {
      return;
    }
    this._selectOptions = value;
    this.selectionChange.emit(this._selectOptions);
  }
  @Output()
  selectionChange = new EventEmitter<DescriptionModel[]>();

  constructor() { }

  ngOnInit(): void {
  }

  onKey(value: string) {
    this.selectOptions = this.onSearch(value);
  }

  onSearch(value: string) {
    let filter = value.toLowerCase();
    return this.allOptions.filter(option => option.description.toLowerCase().startsWith(filter));
  }
}
